const r: any = {
    BaseUrl: process.env.REACT_APP_BASE_URL ?? '',
};

export default r;